var map = {
	"./Filled/FilledCookiePolicy.svg": 96344,
	"./Filled/FilledPrivacyPolicy.svg": 96230,
	"./Filled/FilledRefundPolicy.svg": 23140,
	"./Filled/FilledTOS.svg": 29114,
	"./PrivacyPolicy.svg": 98801,
	"./RefundPolicy.svg": 63357,
	"./TermsOfService.svg": 2642,
	"./add.svg": 57382,
	"./general.svg": 85215,
	"./v2/cookie_policy_icon.svg": 1429,
	"./v2/privacy_policy_icon.svg": 66719,
	"./v2/refund_policy_icon.svg": 63217,
	"./v2/tos_icon.svg": 46082
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76263;